import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import teamReducer from './slices/teamSlice'
import bugReducer from './slices/bugSlice'
import chartReducer from './slices/chartSlice'
import configReducer from './slices/configSlice'
import kbReducer from './slices/kbSlice'
import mediaReducer from './slices/mediaSlice'
import intentReducer from './slices/intentSlice'
import visualFlowReducer from './slices/visualFlowSlice'
import webAnalyticsReducer from './slices/webAnalyticsSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    team: teamReducer,
    bug: bugReducer,
    chart: chartReducer,
    config: configReducer,
    kb: kbReducer,
    media: mediaReducer,
    intent: intentReducer,
    visualFlow: visualFlowReducer,
    webAnalytics: webAnalyticsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})